const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 3 });
const usdPrecise = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 3,
  maximumFractionDigits: 4,
});

/** ZenRows bills in dollars, unlike every price in the rest of the app. */
export function dollars(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : usd.format(value);
}

/** For single calls, where the amount is fractions of a cent. */
export function dollarsPrecise(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : usdPrecise.format(value);
}
